var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer text-center",class:{'gray-theme' : _vm.grayTheme}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navigation-links-wrapper"},[_c('NavigationLinks',{attrs:{"footer-links":_vm.footerLinks,"gray-theme":_vm.grayTheme}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }